module.exports = __webpack_public_path__ + "static/media/metacognition@3x.d587fd42.png";